<template>
	<header id="header" class="main_header">
		<div class="header_nav interior">
			<div class="container">
				<div class="header_nav_content">
					<header-logo :businessInfo="businessInfo" />
					<div class="header_nav_right">
						<div :class="[{ hiddenLogin: loginData.userLoggedIn }, 'login']" id="loginLink">
							<div class="login__button">
								<a class="button button--blue" href="/customerservice.pl">Call Us</a>
							</div>
							<div class="login__button login_function">
								<a class="button" href="javascript:void(0);">LOGIN/SIGNUP</a>
							</div>
						</div>
						<span class="mobile-menu-link toggle-logged-in-information">
							<a v-if="!loginData.userLoggedIn" href="/login.pl"><i class="toc-icon-hamburger"></i></a>
							<i v-else class="toc-icon-hamburger"></i>
							<i class="toc-icon-close" style="display: none"></i>
						</span>
						<div :class="[{ hiddenLogin: !loginData.userLoggedIn }, 'header_login_area']" id="logoutLink">
							<div class="welcome-logout-container">
								<div v-if="loginData.showStaffLink" class="nav_item">
									<a href="/main-admin.pl">staff</a>
								</div>
								<div id="loginName">
									{{ loginData.welcomeMsg }}
								</div>
								<a class="header_login logout button" href="/logout.pl">Logout</a>
							</div>
							<div class="account-links">
								<a class="account-link" href="/edit-profile.pl"><i class="fa fa-user"></i>View Account</a>
								<a
									class="account-link"
									:href="`/custHistory.pl?user=${loginData.userId}&mode=report&beginDateSend=19800101&hour=00&minute=00&endDateSend=${loginData.today}&fhour=23&fminute=59`"
									><i class="fas fa-sync"></i>Reorder/History</a
								>
							</div>
						</div>
						<ul class="header_nav_order_area">
							<li class="my-order-list-item">
								<i class="fas fa-shopping-cart" aria-hidden="true"></i>
								<span id="nav_my_order"> My Order </span>
							</li>
							<li class="total-list-item">
								<a href="#column-right">
									<span id="nav_order_total"> ${{ loginData.total }} </span>
								</a>
							</li>
						</ul>
					</div>
				</div>

				<!--end nav row-->
			</div>
		</div>
	</header>
</template>
<script>
import HeaderLogo from "./HeaderLogo.vue";
export default {
	components: {
		HeaderLogo,
	},
	props: {
		loginData: {
			type: Object,
			required: true,
		},
		businessInfo: {
			type: Object,
		},
	},
};
</script>
<style scoped>
.hiddenLogin {
	display: none;
}
</style>
